// extracted by mini-css-extract-plugin
export default {"LeftRightSelection_container":"styles_LeftRightSelection_container__Jwq2B","icon":"styles_icon__CXEWq"};